import React from 'react';
import { EntityLayout, EntitySwitch } from '@backstage/plugin-catalog';
import { RTLLinksCard } from '../../cards/LinksCard';
import { Grid } from '@material-ui/core';
import { Direction, RelationsGraphCard } from '../../cards/RelationsGraphCard';
import { WarningCard } from '../../cards/WarningCard';
import { LeaderCard } from '../../cards/LeaderCard';
import { RTLMembersListCard } from '../../cards/MembersListCard';
import { useEntity } from '@backstage/plugin-catalog-react';
import { hasOwner, hasTechnicalContacts, notHasOwner } from '../../cards/utils';
import { TechnicalContactsCard } from '../../cards/TechnicalContactsCard';
import { DescriptionCard } from '../../cards/DescriptionCard';

export const OrganizationPage = () => {
  const kinds = ['Group'];
  const { entity } = useEntity();
  if (entity.spec?.type === 'external') {
    kinds.push('System');
  }
  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3} alignItems="stretch">
          <WarningCard />
          <EntitySwitch>
            <EntitySwitch.Case if={hasOwner}>
              <Grid item xs={12} md={hasTechnicalContacts(entity) ? 6 : 12}>
                <LeaderCard />
              </Grid>
            </EntitySwitch.Case>
          </EntitySwitch>
          <EntitySwitch>
            <EntitySwitch.Case if={hasTechnicalContacts}>
              <Grid item xs={12} md={6}>
                <TechnicalContactsCard />
              </Grid>
            </EntitySwitch.Case>
          </EntitySwitch>
          <EntitySwitch>
            <EntitySwitch.Case if={notHasOwner}>
              <RTLLinksCard />
            </EntitySwitch.Case>
          </EntitySwitch>
          <Grid item xs={12}>
            <DescriptionCard />
          </Grid>
          <Grid item xs={12}>
            <RelationsGraphCard
              height={400}
              kinds={kinds}
              direction={Direction.TOP_BOTTOM}
            />
          </Grid>
          <Grid item xs={12}>
            <RTLMembersListCard showAggregateMembersToggle />
          </Grid>
        </Grid>
      </EntityLayout.Route>
    </EntityLayout>
  );
};
